import * as React from 'react'
import * as ReactDOM from 'react-dom'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PortalDefinition<T = any> = {
  el: HTMLElement
  Component: React.ComponentType<T>
  props: T
  key: string
}

const Portal: React.FC<PortalDefinition> = (portal) => {
  return ReactDOM.createPortal(
    <portal.Component {...portal.props} />,
    portal.el
  )
}

export default Portal
